import React, { useEffect, useState } from "react"
import TabsCustom from "src/components/TabsCustom"
import Button from "src/components/MyButton/Button"
import WarehouseEntry from "./components/WarehouseEntry"
import { message, Modal, Spin } from "antd"
import STORAGE from "src/lib/storage"
import WarehouseService from "src/services/WarehouseService"

const Receipt = () => {
  const [disableBtn, setDisableBtn] = useState(false)
  const [filter, setFilter] = useState({})
  const [activeKey, setActiveKey] = useState("all")
  const [warehouseWarning, setWarehouseWarning] = useState(null)
  const [shownError, setShownError] = useState(false)
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
    const [excelKeyword, setExcelKeyword] = useState("")

  const Tabs = {
    all: { type: "warehouse", name: "Tất cả" },
    success: { type: "2", name: "Tồn kho" },
    sell: { type: "4", name: "Đã bán" },
  }

  const items = Object.keys(Tabs).map(key => ({
    key,
    label: <div className="text-tile-tabs">{Tabs[key].name}</div>,
  }))

  const handleExportExcel = async () => {
    try {
      const params = {
        ...filter,
        type: Tabs[activeKey]?.type,
        keyword : excelKeyword
      }

      const response = await WarehouseService.exportData(params)

      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "Danh_sach_kho_Sim.xlsx")
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } else {
        message.error("Không có dữ liệu để xuất Excel.")
      }
    } catch (error) {
      console.error("Lỗi khi xuất Excel:", error)
      message.error("Xuất Excel thất bại.")
    }
  }

  useEffect(() => {
    const fetchWarning = async () => {
      try {
        setLoading(true)
        const res = await WarehouseService.listWarehouseWarning()
        const data = res?.success?.original
        if (data) {
          setWarehouseWarning(data)

          if (data.is_warning) {
            setOpen(true) // Chỉ mở modal khi có cảnh báo
          }
        }
      } catch (err) {
        message.error("Không thể lấy dữ liệu cảnh báo kho.")
      } finally {
        setLoading(false)
      }
    }

    fetchWarning()
  }, [])

  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""
  const hasPermission = permissions.includes("warehouse.sim")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [hasPermission, shownError])

  if (!hasPermission) return null

  return (
    <div style={{ paddingTop: 20 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          marginBottom: 20,
          gap: 12,
        }}
      >
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#005F90",
            margin: 0,
            whiteSpace: "nowrap",
          }}
        >
          KHO SIM
        </h3>

        {permissions.includes("warehouse.sim.export") && (
          <Button btnType="primary1" onClick={handleExportExcel}>
            Xuất Excel
          </Button>
        )}
      </div>

      <TabsCustom
        onChange={key => setActiveKey(key)}
        activeKey={activeKey}
        items={items}
        defaultActiveKey="all"
        type="card"
      />

      <div style={{ marginTop: 20 }}>
        <WarehouseEntry
          type={Tabs[activeKey]?.type}
          setFilter={setFilter}
          filter={filter}
          permissions={permissions}
          setExcelKeyword={setExcelKeyword}
        />
      </div>

      {/* Modal cảnh báo */}
      <Modal
        open={open}
        title={
          !loading && (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {/* <span style={{ fontSize: 22 }}>⚠️</span> */}
              <span style={{ color: "#cf1322", fontWeight: 600, fontSize: 18 }}>
                CẢNH BÁO KHO SIM
              </span>
            </div>
          )
        }
        onCancel={() => setOpen(false)}
        footer={null} // Bỏ footer, chỉ hiện nút đóng mặc định
        centered
        bodyStyle={{ padding: "24px 24px 16px" }}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 140,
            }}
          >
            <Spin tip="Đang tải dữ liệu..." size="large" />
          </div>
        ) : (
          <div
            style={{
              lineHeight: 1.8,
              fontSize: 15,
              color: "#000",
            }}
          >
            <p
              style={{
                fontWeight: "bold",
                color: "#cf1322",
                fontSize: 16,
                marginBottom: 12,
              }}
            >
              {warehouseWarning?.message ||
                "Số lượng SIM trong kho đang thấp hơn mức cho phép!"}
            </p>

            <div
              style={{
                padding: 12,
                border: "1px solid #ffa39e",
                backgroundColor: "#fff1f0",
                borderRadius: 6,
              }}
            >
              <p>
                🧮 <strong>Số lượng SIM còn lại:</strong>{" "}
                <span style={{ color: "#cf1322" }}>
                  {warehouseWarning?.sim_in_stock}
                </span>
              </p>
              <p>
                📤 <strong>Số lượng SIM đã bán:</strong>{" "}
                <span style={{ color: "#cf1322" }}>
                  {warehouseWarning?.sim_sold}
                </span>
              </p>
              <p>
                📊 <strong>Tỉ lệ còn lại:</strong>{" "}
                <span style={{ color: "#cf1322" }}>
                  {warehouseWarning?.remaining_percent}%
                </span>
              </p>
            </div>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default Receipt
